import { render, staticRenderFns } from "./OtsPopPro.vue?vue&type=template&id=1ba516b1&scoped=true&"
import script from "./OtsPopPro.vue?vue&type=script&lang=js&"
export * from "./OtsPopPro.vue?vue&type=script&lang=js&"
import style0 from "./OtsPopPro.vue?vue&type=style&index=0&id=1ba516b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba516b1",
  null
  
)

export default component.exports